import React from 'react'
import Layout from '../../components/layouts/layout'

export default class GeneticsNutrition extends React.Component {
  componentDidMount() {
    window.location.href = "https://www.advanxhealth.com/products/dna-explorer-essential"
  }

  render() {
    return (
      <Layout>
      </Layout>
    )
  }
}
